define('GameDayCore/GDModel/ValueObjects/RealTimeHighlights/Highlights',['require','exports','module','../ValueObjectFactory','./Highlight'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        Highlight = require("./Highlight");

	VO.create(Highlights);

	function Highlights($data) {
        var vo = VO.ensureVO(this, Highlights),
            data = $data,
	        videosArray = [ ],
	        videosCIDHash = { },
	        videosSVIDHash = parseList(data, videosCIDHash, videosArray) || { };

	    vo.videosBySVID = videosSVIDHash;
        vo.videosByCID = videosCIDHash;
        vo.videosArray = videosArray;
        vo.hasVideos = (videosArray.length > 0);
	}

	function parseList($data, $videosCIDHash, $videosArray) {
        var vids = [].concat($data.media),
            videoObj = { };

        for (var i = 0, long = vids.length; i < long; i++) {
            var hilite = new Highlight(vids[i]);
            if (hilite.condensed) { continue; }

            $videosCIDHash["cid_" + hilite.id] = hilite;
            videoObj["rth_" + (hilite.sv_id || hilite.id)] = hilite;
            $videosArray.push(hilite)
        }

        return videoObj;
    }

	return Highlights;
});
